// extracted by mini-css-extract-plugin
export default {"emailColumns":"EmailInputSection_emailColumns__2juuf","emailLabel":"EmailInputSection_emailLabel__efUnp"};